import React from "react";
import { useLanguage } from "../context/LanguageContext";

const Service = () => {
  const { lang } = useLanguage();

  const t = {
    sq: {
      title: "Shërbimet tona IT",
      sub: "Zgjidhje profesionale për pajisjet dhe biznesin tuaj",
      servicesTitle: "Shërbimet",
      ctaTitle: "Ke nevojë për një shërbim?",
      ctaSub: "Na kontakto dhe ne do të të ndihmojmë menjëherë.",
      contact: "Kontakto tani",

      services: [
        {
          title: "Shërbime IT për Biznese",
          icon: "🚀",
          desc: "Zgjidhje të avancuara IT: zhvillim platformash web, automatizim procesesh, marketing digjital dhe siguri rrjeti.",
        },
        {
          title: "Shërbime IT për Familje",
          icon: "🔧",
          desc: "Mbështetje teknike në shtëpi: instalim software, optimizim pajisjesh dhe zgjidhje për çdo problem teknologjik.",
        },
        {
          title: "Riparime Laptop & PC",
          icon: "💻",
          desc: "Diagnostikim dhe riparim hardware/software për laptop dhe desktop.",
        },
        {
          title: "Instalim Software & Mirëmbajtje",
          icon: "⚙️",
          desc: "Instalim sistemi operativ, programe profesionale dhe optimizim për performancë maksimale.",
        },
        {
          title: "Rikuperim të Dhënash",
          icon: "💾",
          desc: "Shpëtim i të dhënave të humbura nga pajisje të dëmtuara me metoda profesionale.",
        },
        {
          title: "Siguri & Antiviruse",
          icon: "🔒",
          desc: "Mbrojtje nga viruset, malware dhe konfigurim sigurie për pajisjet tuaja.",
        },
        {
          title: "Menaxhim Rrjetesh",
          icon: "🌐",
          desc: "Monitorim, konfigurim dhe mirëmbajtje e rrjeteve kompjuterike për performancë dhe siguri maksimale.",
        },
        {
          title: "Web & Marketing",
          icon: "💻📈",
          desc: "Krijim website, menaxhim social media dhe marketing digjital.",
        },
        {
          title: "Optimizim i Faqeve të Internetit",
          icon: "🚀",
          desc: "Përmirësim i shpejtësisë, performancës dhe SEO të faqeve të internetit për ngarkim më të shpejtë dhe renditje më të mirë.",
        },
      ],
    },

    en: {
      title: "Our IT Services",
      sub: "Professional solutions for your devices and business",
      servicesTitle: "Services",
      ctaTitle: "Need a service?",
      ctaSub: "Contact us and we will help you immediately.",
      contact: "Contact now",

      services: [
        {
          title: "IT Services for Businesses",
          icon: "🚀",
          desc: "Advanced IT solutions: web platforms, process automation, digital marketing and network security.",
        },
        {
          title: "IT Services for Home Users",
          icon: "🔧",
          desc: "Home technical support: software installation, device optimization and tech problem solving.",
        },
        {
          title: "Laptop & PC Repair",
          icon: "💻",
          desc: "Hardware/software diagnostics and repair for laptops and desktops.",
        },
        {
          title: "Software Installation & Maintenance",
          icon: "⚙️",
          desc: "OS installation, professional software setup and performance optimization.",
        },
        {
          title: "Data Recovery",
          icon: "💾",
          desc: "Recovery of lost data from damaged devices using professional methods.",
        },
        {
          title: "Security & Antivirus",
          icon: "🔒",
          desc: "Protection from viruses, malware and security configuration for your devices.",
        },
        {
          title: "Network Management",
          icon: "🌐",
          desc: "Monitoring, configuration and maintenance of computer networks for maximum performance and security.",
        },
        {
          title: "Web & Marketing",
          icon: "💻📈",
          desc: "Website creation, social media management and digital marketing.",
        },
        {
          title: "Website Optimization",
          icon: "🚀",
          desc: "Improving speed, performance and SEO for faster loading and better ranking.",
        },
      ],
    },
  };

  const text = t[lang] || t.sq;

  return (
    <div className="bg-gray-100 min-h-screen py-10 px-4">
      <div className="max-w-6xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold">{text.title}</h1>
          <p className="text-gray-600 mt-2">{text.sub}</p>
        </div>

        {/* SERVICES GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {text.services.map((s, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-2xl shadow hover:shadow-xl transition transform hover:scale-105"
            >
              <div className="text-4xl mb-3">{s.icon}</div>
              <h3 className="text-lg font-semibold">{s.title}</h3>
              <p className="text-gray-600 text-sm mt-2">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        {/* CTA */}
        <div className="text-center mt-12">
          <h2 className="text-xl font-semibold mb-3">{text.ctaTitle}</h2>
          <p className="text-gray-500 mb-5">{text.ctaSub}</p>

          <button
            onClick={() => {
              const phone = "355674909765";

              const message =
                lang === "sq"
                  ? `Përshëndetje,\n\nJam i interesuar për shërbimet tuaja .\nJu lutem më kontaktoni.\n\nFaleminderit!`
                  : `Hello,\n\nI am interested in your services.\nPlease contact me.\n\nThank you!`;

              window.open(
                `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
                "_blank",
              );
            }}
            className="bg-green-600 text-white px-6 py-3 rounded-xl hover:bg-green-700 transition"
          >
            {text.contact}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Service;
